/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NotInvited/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function NotInvited({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/PracticeHub/Status/NotInvited"
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Not invited"
 size="small"
/>
{children}
</React.Fragment>)
}